// @ts-strict-ignore
export const scrollToTabSection = (tabId: string, tabItemId: string, offset?: number): void => {
	const tabsElement = document.getElementById(tabId)
	const tabButtonElement = tabsElement.querySelector<HTMLElement>(`[id$="${tabItemId}"]`)

	if (tabButtonElement) {
		tabButtonElement.click()
		setTimeout(() => {
			tabsElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
			if (offset) {
				window.scrollBy({ top: offset, left: 0, behavior: 'smooth' })
			}
		}, 0)
	}
}
